import {CxEvent} from "@spartacus/core";

export class CustomCleanEcommerceEvent extends CxEvent {
  static readonly type = 'CustomCleanEcommerceEvent';
  ecommerce: null;
}
